import React, { useEffect, useState } from "react";
import Search from "../Search/Search";
import CreateNewDocuments from "../ReusedComponents/CreateNewDocuments/CreateNewDocuments";
import { onHandleShowTableMenu } from "../../utils/OnHandleShowTableMenu/OnHandleShowTableMenu";
import moreBtnTableIcon from "../../img/moreButtonTable.svg";
import TableRowMenu from "../ReusedComponents/TableRowMenu/TableRowMenu";
import SelectedDocSetMan from "../SelectedDocSetMan/SelectedDocSetMan";
import { findStatusDocument } from "../../utils/FindStatusDocument/FindStatusDocument";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import CreateDocSetManModal from "../CreateDocSetManModal/CreateDocSetManModal";
import { axiosGetCargoCaseId } from "../../Api/ApiCargoCase/axiosGetCargoCaseId";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import { axiosPutUpdateManOnlyMansTable } from "../../Api/ApiMan/axiosPutUpdateManOnlyMansTable";
import { filtredArrayBolsSelectedMan } from "../../utils/FiltredArrayBolsSelectedMan/FiltredArrayBolsSelectedMan";
import { filtredArrayBblsSumBolsSelectedMan } from "../../utils/FiltredArrayBblsSumBolsSelectedMan/FiltredArrayBblsSumBolsSelectedMan";

const Man = (props) => {
  const { getListMan } = props;

  const [filter, setFilter] = useState("");
  const axiosPrivate = useAxiosPrivate();
  const [editDoc, setEditDoc] = useState(false);
  const [isBolsNumbers, setBolsNumbers] = useState([]);
  const [isSumBBLSgross, setSumBBLSgross] = useState(0);
  const [activeTableRowMenu, setActiveTableRowMenu] = useState(null);
  const [activeManTable, setActiveManTable] = useState(true);
  const [selectedCargoCase, setSelectedCargoCase] = useState([]);
  const [activeSelectDoc, setActiveSelectDoc] = useState(false);
  const [selectedCargoCaseMan, setSelectedCargoCaseMan] = useState([]);
  const [activeCreateManModal, setActiveCreateManModal] = useState(false);
  const {
    setNameDocHeader,
    getRequestDataToggle,
    getIdUpdateMan,
    cleanIdUpdateMan,
    stateReducer,
  } = useAuth();

  useEffect(() => {
    let isMounted = true;

    if (getListMan.length > 0) {
      isMounted && setActiveManTable(true);
      if (activeSelectDoc === false) {
        filtredArrayBolsSelectedMan(getListMan, isMounted, setBolsNumbers);
        filtredArrayBblsSumBolsSelectedMan(
          getListMan,
          isMounted,
          setSumBBLSgross
        );
      }
    } else {
      isMounted && setActiveManTable(false);
    }

    return () => {
      isMounted = false;
    };
  }, [getListMan, activeSelectDoc]);

  function onShowCurrentDoc(id, i) {
    const currentCargoCaseMan = getListMan.find((el) => el?.id === id);
    setActiveSelectDoc(true);
    setNameDocHeader(currentCargoCaseMan?.number);
    setSelectedCargoCaseMan([currentCargoCaseMan]);
    setBolsNumbers(isBolsNumbers[i]);
  }

  useEffect(() => {
    let isLoading = true;

    if (selectedCargoCaseMan[0]?.cargoCase?.id !== undefined) {
      axiosGetCargoCaseId(
        axiosPrivate,
        selectedCargoCaseMan[0]?.cargoCase?.id,
        isLoading,
        setSelectedCargoCase
      );
    }
    return () => {
      isLoading = false;
    };
  }, [selectedCargoCaseMan]);

  function onEditActiveMode() {
    if (editDoc === false && selectedCargoCase !== undefined) {
      setActiveCreateManModal(true);
      setEditDoc(true);
    }
  }

  const closeModal = () => {
    setActiveCreateManModal(false);
    setEditDoc(false);
  };

  function addManCargoCase(body, cargoCaseId, manId) {
    if (editDoc === true && manId !== undefined) {
      axiosPutUpdateManOnlyMansTable(
        axiosPrivate,
        manId,
        body,
        getRequestDataToggle,
        getIdUpdateMan,
        setActiveCreateManModal,
        setEditDoc
      );
    } else {
      closeModal();
    }
  }

  useEffect(() => {
    if (stateReducer.idUpdateMan !== null) {
      const currentCargoCaseMan = getListMan.find(
        (el) => el?.id === stateReducer.idUpdateMan
      );
      setNameDocHeader(currentCargoCaseMan?.number);
      setSelectedCargoCaseMan([currentCargoCaseMan]);
      cleanIdUpdateMan();
    }
  }, [getListMan]);

  useEffect(() => {
    let isMounted = true;

    isMounted && setActiveManTable(true);
    isMounted && setActiveSelectDoc(false);
    isMounted && setNameDocHeader("");
    isMounted && setSelectedCargoCaseMan([]);
    isMounted && setSelectedCargoCase([]);
    isMounted && setActiveTableRowMenu(null);
    isMounted &&
      filtredArrayBolsSelectedMan(getListMan, isMounted, setBolsNumbers);
    isMounted &&
      filtredArrayBblsSumBolsSelectedMan(
        getListMan,
        isMounted,
        setSumBBLSgross
      );

    return () => {
      isMounted = false;
    };
  }, [stateReducer.toggleBackPage]);

  return (
    <div className="man__container">
      <div
        className={
          activeSelectDoc
            ? "man-search-create-button hide"
            : "man-search-create-button"
        }
      >
        <Search value={filter} setValue={setFilter} />
      </div>
      <div className="man-main-block">
        {activeManTable ? (
          <>
            {activeSelectDoc ? (
              <div className="man__selected">
                <SelectedDocSetMan
                  selectedCargoCaseMan={selectedCargoCaseMan}
                  cargoCaseDocId={selectedCargoCaseMan[0]?.cargoCase?.id}
                  onEditHandler={() => onEditActiveMode()}
                  isBolsNumbers={isBolsNumbers}
                />
              </div>
            ) : (
              <div className="man__table">
                <div className="man__table-block">
                  <div className="man__table-header">
                    <p>MAN No.</p>
                    <p>B/L No.</p>
                    <p>Port of loading</p>
                    <p>Port of discharging</p>
                    <p>Flag</p>
                    <p>BBLS gross</p>
                    <p>Carrier</p>
                    <p>Status</p>
                  </div>
                  {getListMan
                    .filter((el) => el?.number.includes(filter))
                    .map((el, i) => {
                      return (
                        <div
                          onClick={() => onShowCurrentDoc(el.id, i)}
                          key={el?.id}
                          className="man__table-row"
                        >
                          <p>{el?.number}</p>
                          <p>{isBolsNumbers[i]?.toString()}</p>
                          <p>{el?.portOfLoading?.name}</p>
                          <p>{el?.portOfDischarge?.name}</p>
                          <p>{el?.vessel?.country?.name}</p>
                          <p>{isSumBBLSgross[i]?.toString()}</p>
                          <p>{el?.shipowner?.name}</p>
                          <div className="cargo-case-table-row-status">
                            <img
                              className="cargo-case-table-row-status__icon-prepared"
                              src={findStatusDocument(el?.status)}
                              alt={"иконка подготовлен"}
                            />
                            {/* <img onClick={(e) => onHandleShowTableMenu(el?.id, activeTableRowMenu, setActiveTableRowMenu, e)} className="cargo-case-table-row-status__icon-more-btn" src={moreBtnTableIcon} alt={'иконка показать больше'}/>
                                                    <TableRowMenu
                                                        index={el?.id}
                                                        activeTableRowMenu={activeTableRowMenu}
                                                        handelTableMenu={onSelectedBol}
                                                    /> */}
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <CreateNewDocuments hiddenButtons={true} />
          </>
        )}
      </div>
      {activeCreateManModal && (
        <CreateDocSetManModal
          closeModal={closeModal}
          cargoCaseDocument={selectedCargoCase}
          addManCargoCase={addManCargoCase}
          editDoc={editDoc}
          selectedCargoCaseMan={selectedCargoCaseMan}
        />
      )}
    </div>
  );
};
export default Man;
